// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"453c83fb","667":"a0e03df8","977":"ec538307"}[chunkId] + ".chunk.js";
};